<template>
  <div v-loading='isLoading' class='edit-attached-files-section attachment'
       @dragover.prevent='dragEnter'
       @dragleave.prevent='dragLeave'
       @drop.prevent='dropFile'
       :class='{enter: dragin}'
  >
    <div class='sub-heading'>
      <tw-button type='secondary' size='medium' class='choose_file' @click='loadFile'>
        Choose Local File
        <input ref='fileInput' class='file_input' @change='setFile' type='file' multiple
               :accept="'.' + WHITE_LIST.join(',.')">
      </tw-button>
      <tw-button v-if="tradingDocuments" type="secondary" icon="plus" size="medium" @click="showDocumentsDialog">
        Select
      </tw-button>
    </div>

    <!-- 同一取引内の帳票を選択 -->
    <el-dialog :title="$t('Label.Add Select File')" :visible.sync="dialogAddDocumentsVisible" :close-on-click-modal="false" class="header_border" width="980px" aria-label="Add Select File" :append-to-body="true">
      <TwAddDocuments v-if="dialogAddDocumentsVisible" ref="addDocumentsDialog" :items="tradingDocuments" :tradingName="tradingManageName" :flowName="tradingFlowName" @add-documents="addDocuments" @download="download" />
    </el-dialog>

    <!--  Files from API  -->
    <el-form :model='documentsForm' ref='documentsForm' @validate='onValidate'>
      <template v-for='(doc, index) in documentsForm.existingDocuments'>
        <div v-if='doc.documentEditFlg !== DOCUMENT_EDIT_FLG.DELETE' class='file' :key='`existing-files-${index}`'>
          <div class='inner'>
            <div class='user'>
              <figure v-if='doc.updateUserIcon' class='avatar table'><img :src='doc.updateUserIcon' alt=''></figure>

              <div class='from_name'>{{ doc.updateUserName }}</div>
            </div>

            <el-tooltip placement='top-start' popper-class='mcu' :tabindex='-1'>
              <div slot='content'>{{ doc.documentName }}</div>

              <span>
                <a class='file_name' @click.prevent='download(doc)' tabindex='-1'>{{ doc.documentName }}</a>
              </span>
            </el-tooltip>

            <span class='meta'>{{ doc.updateDate | dateTimeFormat }},&nbsp;{{ doc.documentSize | fileSize }}</span>

            <template v-if='doc.documentEditFlg !== DOCUMENT_EDIT_FLG.DELETE && doc.documentPath && s.isPdf(doc)'>
              <el-tooltip placement='top' popper-class='mcu' :tabindex='-1'>
                <div slot='content'>PDF Preview（⌘/Ctrl＋クリックで別タブ）</div>
                <img @click='s.onPreviewPdfClick(doc, $event)' style='cursor:pointer;margin-left: 16px'
                     src='@/assets/images/icons/icon_pdf_preview.svg' alt=''>
              </el-tooltip>
              <el-tooltip placement='top' popper-class='mcu' :tabindex='-1'>
                <div slot='content'>Open in New Tab</div>
                <!-- ★width:25px でプレビューアイコン（25×25）と大きさを揃える -->
                <img @click='s.previewPdfNewTab(doc)' style='cursor:pointer;margin-left: 16px; width:25px;'
                     src='@/assets/images/icons/icon_external_link.svg' alt=''>
              </el-tooltip>
            </template>
            <div class=checkbox-group>
              <div>
                <el-checkbox v-for="item in documentCheckbox" :key="item.id + '-' + index" :checked="doc['documentLink' + getDocumentKey(item.code)]" :true-label="1" :false-label="0" @change="updateUploadedDocumentsCategories(doc, item, index)">
                  <span>{{ item.label }}</span>
                </el-checkbox>
              </div>
              <div class="others_checkbox">
                <el-checkbox v-for="item in documentOthersCheckbox" :key="item.id + '-' + index" :checked="doc['documentLink' + getDocumentKey(item.code)]" :true-label="1" :false-label="0" @change="updateUploadedDocumentsCategories(doc, item, index)">
                  <span>{{ item.label }}</span>
                  <el-input v-model="doc['documentLinkLabel' + getDocumentKey(item.code)]" :readonly="!doc['documentLink' + getDocumentKey(item.code)]" @change='onCommentChange(doc, index)' class="document_input" style="width: 120px;" maxlength="30" show-word-limit />
                </el-checkbox>
              </div>
            </div>
          </div>

          <el-form-item :prop='`existingDocuments[${index}].documentCommentText`'
                        :rules="[{ max: 100, message: 'Free Textは100文字以内で入力してください', trigger: 'blur' }]">
            <el-input type='textarea' :autosize='{ minRows: 1, maxRows: 6}' v-model='doc.documentCommentText'
                      @change='onCommentChange(doc, index)'
                      maxlength='100' show-word-limit />
          </el-form-item>

          <!-- Todo: 削除フラグの動作確認 -->
          <img v-if='doc.documentDeletable === DELETE_ABLE_FLG.OK'
               class='close_times' src='@/assets/images/icons/times_black.svg'
               @click.stop.prevent='removeAttachedFile(doc, index)' alt=''>
        </div>
      </template>

      <!--  Uploaded files  -->
      <template v-for='(doc, index) in documentsForm.uploadedDocuments'>
        <div class='file uploaded-files' :key='`uploaded-files-${index}`'>
          <div class='inner'>
            <el-tooltip placement='top-start' popper-class='mcu' :tabindex='-1'>
              <div slot='content'>{{ doc.documentName }}</div>

              <span>
                  <a v-if='doc.documentValue' class='file_name' :href='doc.documentValue' :download='doc.documentName'>
                    {{ doc.documentName }}</a>
                  <a v-else class='file_name' @click.prevent='download(doc)' tabindex='-1'>{{ doc.documentName }}</a>
                </span>
            </el-tooltip>

            <span class='meta'>{{ doc.updateDate | dateTimeFormat }},&nbsp;{{ doc.documentSize | fileSize }}</span>

            <template v-if='s.isPdf(doc)'>
              <el-tooltip placement='top' popper-class='mcu' :tabindex='-1'>
                <div slot='content'>PDF Preview（⌘/Ctrl＋クリックで別タブ）</div>
                <img @click='s.onPreviewPdfClick(doc, $event)' style='cursor:pointer;margin-left: 16px'
                     src='@/assets/images/icons/icon_pdf_preview.svg' alt=''>
              </el-tooltip>
              <el-tooltip placement='top' popper-class='mcu' :tabindex='-1'>
                <div slot='content'>Open in New Tab</div>
                <!-- ★width:25px でプレビューアイコン（25×25）と大きさを揃える -->
                <img @click='s.previewPdfNewTab(doc)' style='cursor:pointer;margin-left: 16px; width:25px;'
                     src='@/assets/images/icons/icon_external_link.svg' alt=''>
              </el-tooltip>
            </template>
            <div class=checkbox-group>
              <div>
                <el-checkbox v-for="item in documentCheckbox" :key="item.id + '-' + index" :checked="!!doc['documentLink' + getDocumentKey(item.code)]" @change="updateUploadedDocumentsCategories(doc, item, index)">
                  <span style="font-size: 14px">{{ item.label }}</span>
                </el-checkbox>
              </div>
              <div class="others_checkbox">
                <el-checkbox v-for="item in documentOthersCheckbox" :key="item.id + '-' + index" :checked="!!doc['documentLink' + getDocumentKey(item.code)]" @change="updateUploadedDocumentsCategories(doc, item, index)">
                  <span style="font-size: 14px">{{ item.label }}</span>
                  <el-input v-model="doc['documentLinkLabel' + getDocumentKey(item.code)]" :readonly="!doc['documentLink' + getDocumentKey(item.code)]" class="document_input" style="width: 100px;" maxlength="30" show-word-limit />
                </el-checkbox>
              </div>
            </div>
          </div>

          <el-form-item :prop='`uploadedDocuments[${index}].documentCommentText`'
                        :rules="[{ max: 100, message: 'Free Textは100文字以内で入力してください', trigger: 'blur' }]">
            <el-input type='textarea' :autosize='{ minRows: 1, maxRows: 6}' v-model='doc.documentCommentText'
                      maxlength='100' show-word-limit />
          </el-form-item>

          <img class='close_times' src='@/assets/images/icons/times_black.svg' @click.stop.prevent='removeFile(index)'
               alt=''>
        </div>
      </template>
    </el-form>

    <div class='drag_and_drop_area'>
      <img src='@/assets/images/dropfile.svg' alt=''>
      Drop files here to upload.
    </div>

    <div v-if='errorMessages' style='margin-top: 40px'>
      <el-alert
        title='Error'
        type='error'
      >
        <ul>
          <li v-for='(item, index) in errorMessages' :key='index' class=''>
            {{ item.message }}
          </li>
        </ul>
      </el-alert>
    </div>

    <div v-if="needApplyButton" class="edit-attached-files-warning">
      {{ $t('Message.Edit Atached Files Warning Message') }}
    </div>
    <div style='display: flex;justify-content: flex-end;padding-top: 8px;gap: 8px;'>
      <tw-button type='secondary' size='medium' @click='register' :disabled="!fileActionOccurred">{{ $t('Label.Save') }}</tw-button>
      <tw-button v-if="needApplyButton" type='primary' size='medium' @click='requestApproval' :disabled="!fileActionOccurred">{{ applyButtonLabel }}</tw-button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import {
  ATTACH_FILE_EXTENSION_CO_VARIABLES,
  ATTACH_FILE_EXTENSION_VARIABLES,
  PROCESS_TYPE, DOCUMENT_EDIT_FLG, CO_DOCUMENT_ID_VARIABLES, DELETE_ABLE_FLG,DOCUMENT_LINK_VARIABLES, PROCESS_PROGRESS_STATUS,RESPONSIBLE_FLG, PROCESS_OPERATION,
} from 'lib-tw-common';
import TwButton from '@/components/atoms/TwButton';
import { $api } from '../../store/ApiClient';

export default {
  name: 'TwFileUploadSection',
  inject: ['s'],
  components: {
    TwButton,
    TwAddDocuments: () => import('@/components/organisms/TwAddDocuments'),
  },
  data() {
    return {
      WHITE_LIST: [],
      DOCUMENT_EDIT_FLG,
    
      CO_DOCUMENT_ID_VARIABLES,
      DELETE_ABLE_FLG,
      DOCUMENT_LINK_VARIABLES,
      documentsForm: {
        uploadedDocuments: [],
        existingDocuments: []
      },
      dialogAddDocumentsVisible: false,
      tradingManageName: '',
      tradingFlowName: '',
      tradingDocuments: [], // 同フロー・別プロセスの帳票を添付できる、「+Select」ボタン押下後の「ファイル追加」画面に表示される取引帳票リスト
      dragin: false,
      isLoading: false,
      initialUpdateDate: null,
      pathParams: {
        entityId: this.s.entityId,
        processId: this.s.processId,
        processSeq: this.s.processSeq
      },
      getParams: {
        lslConfig: {
          serviceCode: 'tw-transaction-bff-api',
          apiCode: 'get_/v1/process-documents/{entityId}/{processId}/{processSeq}'
        }
      },
      postParams: {
        lslConfig: {
          serviceCode: 'tw-transaction-bff-api',
          apiCode: 'post_/v1/process-documents/{entityId}/{processId}/{processSeq}'
        },
        data: {
          meta: {
            updateDate: null,
          },
          documents: undefined
        }
      },
      errorMessages: null,
      fileActionOccurred: false
    };
  },
  created() {
    // CO申請のみPDFファイルのみを受け付ける
    this.WHITE_LIST = (this.processType === PROCESS_TYPE.FDCOR) ? _.uniq(_.map(ATTACH_FILE_EXTENSION_CO_VARIABLES, o => o.label.toLowerCase())) : _.uniq(_.map(ATTACH_FILE_EXTENSION_VARIABLES, o => o.label.toLowerCase()));
  },
  methods: {
    resetDialog() {
      this.documentsForm.uploadedDocuments = [];
      this.documentsForm.existingDocuments = [];
      this.errorMessages = null;
    },
    // Fetch existing files
    fetchUploadedFiles() {
      this.isLoading = true;
      this.fileActionOccurred = false;

      const params = _.cloneDeep(this.getParams);
      params.lslConfig.path = this.pathParams;

      $api.request(params).then(response => {
        if (response?.documents) {
          this.documentsForm.existingDocuments = response?.documents;
          this.documentsForm.existingDocuments.forEach(doc => {
            DOCUMENT_LINK_VARIABLES.forEach(item => {
              const key = `documentLink${this.getDocumentKey(item.code)}`;
              if (doc[key] !== undefined) {
                this.$set(doc, key, doc[key] === 1);
              }
            });
          });
        }
        if (response?.meta) {
          this.initialUpdateDate = response.meta.updateDate;
          this.tradingManageName = response.meta.tradingManageName;
          this.tradingFlowName = response.meta.tradingFlowName;
        }
        if (response?.tradingDocuments) {
          this.tradingDocuments = response?.tradingDocuments;
        }
      })
        .catch(err => {
          this.$store.dispatch('SHOW_ALERT', err.message);
          if (this.$refs.twSearchFieldRef) this.$refs.twSearchFieldRef.onClearAllFiltersClick();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    // 同一取引内の帳票選択ダイアログを開く
    showDocumentsDialog() {
      getSelection().removeAllRanges(); // テキストの選択をクリアします
      this.dialogAddDocumentsVisible = true;
    },
    // 同一取引内の帳票を添付する
    addDocuments(files) {
      this.dialogAddDocumentsVisible = false;
      _.forEach(files, file => {
        const documentId = (file.processId.startsWith('FDCOR')) ? _.find(CO_DOCUMENT_ID_VARIABLES, {code: file.documentCommentText}) : null;
        this.documentsForm.uploadedDocuments.push({
          updateDate: new Date(),
          documentSize: file.documentSize,
          documentName: file.documentName,
          documentEditFlg: DOCUMENT_EDIT_FLG.RE_REGIST,
          // 同一フロー内の添付資料を引用する時、コメントは引用せず、新規に入力するため documentCommentはカラにする
          documentComment: documentId ? documentId.label : '',
          documentPath: file.documentPath,
          documentManageId: file.documentManageId,
          documentTrx: file.documentTrx,
          documentLinkInv: file.documentLinkInv,
          documentLinkPl: file.documentLinkPl,
          documentLinkSi: file.documentLinkSi,
          documentLinkAn: file.documentLinkAn,
          documentLinkBl: file.documentLinkBl,
          documentLinkCo: file.documentLinkCo,
          documentLinkOthers1: file.documentLinkOthers1,
          documentLinkOthers2: file.documentLinkOthers2,
          documentLinkOthers3: file.documentLinkOthers3,
          documentLinkOthers4: file.documentLinkOthers4,
          documentLinkOthers5: file.documentLinkOthers5,
          documentLinkLabelOthers1: file.documentLinkLabelOthers1,
          documentLinkLabelOthers2: file.documentLinkLabelOthers2,
          documentLinkLabelOthers3: file.documentLinkLabelOthers3,
          documentLinkLabelOthers4: file.documentLinkLabelOthers4,
          documentLinkLabelOthers5: file.documentLinkLabelOthers5,
          documentLinkContract: file.documentLinkContract,
          documentLinkDn: file.documentLinkDn,
          documentLinkPo: file.documentLinkPo
        });
      });
      this.fileActionOccurred = true;
    },
    download(doc) {
      const path = {
        documentManageId: doc.documentManageId,
        documentTrx: doc.documentTrx
      };

      $api
      .download(path, doc.documentName)
      .then(() => {
      })
      .catch(err => {
        this.$store.dispatch('SHOW_ALERT', err.message);
      });
    },

    // Post new files and updated files
    postFiles() {
      this.loading = true;

      const params = _.cloneDeep(this.postParams);
      params.lslConfig.path = this.pathParams;

      const existingDocuments = this.documentsForm.existingDocuments.map(document => ({
        documentEditFlg: document.documentEditFlg,
        documentManageId: document.documentManageId,
        documentTrx: document.documentTrx,
        documentName: document.documentName,
        documentValue: document.documentValue,
        documentPath: document.documentPath,
        documentCommentText: document.documentCommentText,
        ...this.mapDocumentLinks(document),
      }));

      params.data.documents = [...existingDocuments, ...this.mapUploadedDocuments()];
      params.data.meta.updateDate = this.initialUpdateDate;

      this.$store.commit('START_PROCESS');
      return $api.request(params)
        .then(response => {
          if (response) {
            this.$emit('onSuccess');
            this.$emit('update-attached-files');
            this.$store.commit('END_PROCESS');
            this.$store.dispatch('SHOW_COMPLETED');
          }
        })
        .catch(err => {
          this.$store.commit('END_PROCESS');
          if (Array.isArray(err.response?.errors)) {
            this.errorMessages = err.response.errors;
            throw err;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    dragEnter() {
      this.dragin = true;
    },
    dragLeave() {
      this.dragin = false;
    },
    dropFile(e) {
      this.dragin = false;
      this.setFile(e);
    },
    loadFile() {
      this.$refs.fileInput.click();
    },
    setFile(e) {
      // PB-734 ファイルが選択されたことを起因にファイル操作発生フラグをtrue
      this.fileActionOccurred = true;

      const files = _.get(e, 'target.files[0]') ? e.target.files : e.dataTransfer.files;
      const _file = _.get(e, 'target.files[0]') || _.get(e, 'dataTransfer.files[0]');
      if (!_file) {
        return;
      }
      if (files.length + this.documentsForm.uploadedDocuments.length > 10) {
        this.$store.dispatch('SHOW_ALERT', this.$t('Message.ERROR__FILE_COUNT_LIMIT_ERROR', { maxFileCount : '10' }));
        return;
      }
      if (_.some(files, file => {
        if (file.name.length > 100) {
          this.$store.dispatch('SHOW_ALERT', this.$t('Message.ERROR__FILE_NAME_TOO_LONG'));
          return true;
        }
      })) {
        return;
      }
      if (_.some(files, file => {
        if (file.size > 31457280) {
          this.$store.dispatch('SHOW_ALERT', this.$t('Message.ERROR__FILE_SIZE_LIMIT_EXCEEDED_PROCESS_ATTACHED'));
          return true;
        }
      })) {
        return;
      }
      if (_.some(files, file => {
        if (!this.WHITE_LIST.includes(this.s.getFileExtension(file.name))) {
          this.$store.dispatch('SHOW_ALERT', this.$t('Message.ERROR__FILE_EXTENSION_ERROR', { permittedFileExtensions : `${this.WHITE_LIST.join(',')}` }));
          return true;
        }
      })) {
        return;
      }

      if (typeof FileReader === 'function') {
        _.forEach(files, file => {
          const reader = new FileReader();
          reader.onload = event => {
            this.documentsForm.uploadedDocuments.push({
              documentSize: file.size,
              documentName: file.name,
              documentValue: event.target.result,
              documentEditFlg: DOCUMENT_EDIT_FLG.REGIST,
              documentCommentText: '',
              documentLinkInv: null,
              documentLinkPl: null,
              documentLinkSi: null,
              documentLinkAn: null,
              documentLinkBl: null,
              documentLinkCo: null,
              documentLinkOthers1: null,
              documentLinkOthers2: null,
              documentLinkOthers3: null,
              documentLinkOthers4: null,
              documentLinkOthers5: null,
              documentLinkLabelOthers1: "",
              documentLinkLabelOthers2: "",
              documentLinkLabelOthers3: "",
              documentLinkLabelOthers4: "",
              documentLinkLabelOthers5: "",
              documentLinkContract: null,
              documentLinkDn: null,
              documentLinkPo: null
            });
            e.target.value = '';
          };
          reader.readAsDataURL(file);
        });
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    // 添付ファイル削除（登録前）
    removeFile(index) {
      this.$store
        .dispatch('SHOW_CONFIRM', this.$t('Message.CONFIRM__FILE_DELETE_SINGLE'))
        .then(() => {
          this.documentsForm.uploadedDocuments.splice(index, 1);
        })
        .catch(() => {
        });
    },
    // 添付ファイル削除（登録後）
    removeAttachedFile(doc, index) {

      this.$store
        .dispatch('SHOW_CONFIRM', this.$t('Message.CONFIRM__FILE_DELETE_SINGLE'))
        .then(() => {
          // PB-734 ファイルが削除されたことを起因にファイル操作発生フラグをtrue
          this.fileActionOccurred = true;

          doc.documentEditFlg = DOCUMENT_EDIT_FLG.DELETE;
          this.$set(this.documentsForm.existingDocuments, index, doc);
        })
        .catch(() => {
        });
    },
    onCommentChange(doc, index) {
      // PB-734 コメントが修正されたことを起因にファイル操作発生フラグをtrue
      this.fileActionOccurred = true;

      doc.documentEditFlg = DOCUMENT_EDIT_FLG.UPDATE;
      this.$set(this.documentsForm.existingDocuments, index, doc);
    },
    documentsValidation() {
      return new Promise((resolve, reject) => {
        this.$refs.documentsForm.validate((valid) => {
          if (valid) {
            resolve();
          } else {
            this.$store.dispatch('SHOW_ALERT', this.$t('Message.ERROR__INPUT_INVALID'));
            reject();
          }
        });
      });
    },
    onValidate() {
      requestAnimationFrame(() => {
        const files = this.$refs.documentsForm.$el.querySelectorAll('.file');
        files.forEach(el => {
          if (el.querySelector('.is-error')) {
            el.classList.add('has_error');
          } else {
            el.classList.remove('has_error');
          }
        });
      });
    },
    save() {
      const action = this.s.tradeManagement.responsibleFlg === RESPONSIBLE_FLG.FROM ? PROCESS_OPERATION.F_SAVING : PROCESS_OPERATION.T_SAVING;
      this.$emit('save', action, this.createPostDocuments());
      this.$emit('onSuccess');
      this.$emit('update-attached-files');
    },
    register() {
      this.documentsValidation()
        .then(() => {
          const status = this.s?.tradeManagement?.processProgressStatus;

          if (status === PROCESS_PROGRESS_STATUS.NOT_STARTED) {
            this.save();
            return;
          }

          this.postFiles();
        })
        .catch(() => {
          return false;
        });
    },
    updateUploadedDocumentsCategories(doc, item, index){
      const linkKey = `documentLink${this.getDocumentKey(item.code)}`;
      const labelKey = `documentLinkLabel${this.getDocumentKey(item.code)}`;

      doc[linkKey] = !doc[linkKey];
      if (!doc[linkKey]) {
        doc[labelKey] = "";
      }
      if (this.documentsForm.existingDocuments.includes(doc)) {
        doc.documentEditFlg = this.DOCUMENT_EDIT_FLG.UPDATE;
        this.$set(this.documentsForm.existingDocuments, index, doc);
      }
      this.fileActionOccurred = true;
    },
    getDocumentKey(code){
      const Key = {
        1: "Inv",
        2: "Pl",
        3: "Bl",
        4: "An",
        5: "Si",
        6: "Co",
        7: "Others1",
        8: "Others2",
        9: "Others3",
        10: "Others4",
        11: "Others5",
        12: 'Contract',
        13: 'Dn',
        14: 'Po'
      };
      return Key[code] || "";
    },
    hasRequiredFieldErrors() {
      const schemas = this.s.schemas;
      const cloneItems = this.s.cloneItems;
      const responsibleFlg = this.s.tradeManagement?.responsibleFlg;
      const fromToKey = responsibleFlg === RESPONSIBLE_FLG.FROM ? 'from' : 'to';

      if (!schemas || !cloneItems) return false;

      for (const tableSchema of schemas.tables) {
        const tableName = tableSchema.variableName;
        const tableData = _.get(cloneItems, tableName);
        if (tableData === undefined || tableData === null) continue;

        const isArray = Array.isArray(tableData);
        const rows = isArray ? tableData : [tableData];

        for (const row of rows) {
          // 配列テーブルの場合、行内にひとつも入力がなければスキップ
          if (isArray) {
            const hasAnyValue = tableSchema.groups.some(gs => {
              const group = row[gs.variableName];
              return group && Object.values(group).some(v => v !== null && v !== undefined && v !== '');
            });
            if (!hasAnyValue) continue;
          }

          for (const groupSchema of tableSchema.groups) {
            const groupName = groupSchema.variableName;
            const group = row[groupName];
            if (!group) continue;

            for (const itemSchema of groupSchema.children) {
              if (itemSchema.hide) continue;
              if (!itemSchema[fromToKey]) continue;

              const value = group[itemSchema.key];
              const isEmpty = value === null || value === undefined || value === '';
              if (!isEmpty) continue;

              // tw-isNotEmpty: 単独必須
              if (!_.isEmpty(itemSchema.validationId) && itemSchema.validationId.includes('tw-isNotEmpty')) {
                return true;
              }

              // tw-isNotEmptyAorB: ペアのどちらかが入力されていればOK
              const aorBRelations = _.filter(_.get(itemSchema, 'target.relations'), o => o.validationId === 'tw-isNotEmptyAorB');
              for (const relation of aorBRelations) {
                const pairedValue = _.get(cloneItems, relation.target);
                if (pairedValue === null || pairedValue === undefined || pairedValue === '') {
                  return true;
                }
              }
            }
          }
        }
      }
      return false;
    },
    convertBooleanToNumber(value) {
      return value ? 1 : 0;
    },
    mapDocumentLinks(document) {
      return {
        documentLinkInv: this.convertBooleanToNumber(document.documentLinkInv),
        documentLinkPl: this.convertBooleanToNumber(document.documentLinkPl),
        documentLinkSi: this.convertBooleanToNumber(document.documentLinkSi),
        documentLinkAn: this.convertBooleanToNumber(document.documentLinkAn),
        documentLinkBl: this.convertBooleanToNumber(document.documentLinkBl),
        documentLinkCo: this.convertBooleanToNumber(document.documentLinkCo),
        documentLinkOthers1: this.convertBooleanToNumber(document.documentLinkOthers1),
        documentLinkOthers2: this.convertBooleanToNumber(document.documentLinkOthers2),
        documentLinkOthers3: this.convertBooleanToNumber(document.documentLinkOthers3),
        documentLinkOthers4: this.convertBooleanToNumber(document.documentLinkOthers4),
        documentLinkOthers5: this.convertBooleanToNumber(document.documentLinkOthers5),
        documentLinkLabelOthers1: document.documentLinkLabelOthers1,
        documentLinkLabelOthers2: document.documentLinkLabelOthers2,
        documentLinkLabelOthers3: document.documentLinkLabelOthers3,
        documentLinkLabelOthers4: document.documentLinkLabelOthers4,
        documentLinkLabelOthers5: document.documentLinkLabelOthers5,
        documentLinkContract: this.convertBooleanToNumber(document.documentLinkContract),
        documentLinkDn: this.convertBooleanToNumber(document.documentLinkDn),
        documentLinkPo: this.convertBooleanToNumber(document.documentLinkPo),
      };
    },
    mapUploadedDocuments() {
      return this.documentsForm.uploadedDocuments.map(document => ({
        documentEditFlg: document.documentEditFlg,
        documentName: document.documentName,
        documentValue: document.documentValue,
        documentPath: document.documentPath,
        documentCommentText: document.documentCommentText,
        ...this.mapDocumentLinks(document),
      }));
    },
    createApprovalDocuments() {
      const existingDocuments = this.documentsForm.existingDocuments.map(document => ({
        documentArchiveId: document.documentArchiveId,
        documentEditFlg: document.documentEditFlg || DOCUMENT_EDIT_FLG.NO_EDIT,
        documentComment: document.documentCommentText,
        ...this.mapDocumentLinks(document),
      }));
      return [...existingDocuments, ...this.mapUploadedDocuments()];
    },
    requestApproval() {
      if (this.hasRequiredFieldErrors()) {
        this.$store.dispatch('SHOW_ALERT', this.$t('Message.ERROR__INPUT_INVALID'));
        return;
      }
      this.documentsValidation()
        .then(() => {
          const action = this.s.tradeManagement.responsibleFlg === RESPONSIBLE_FLG.FROM
            ? PROCESS_OPERATION.F_APPROVE_REQ
            : PROCESS_OPERATION.T_APPROVE_REQ;
          this.$emit('approval-request', action, this.createApprovalDocuments());
        })
        .catch(() => {
          return false;
        });
    },
    createPostDocuments() {
      const existingDocuments = this.documentsForm.existingDocuments.map(document => ({
        documentEditFlg: document.documentEditFlg,
        documentManageId: document.documentManageId,
        documentTrx: document.documentTrx,
        documentName: document.documentName,
        documentValue: document.documentValue,
        documentPath: document.documentPath,
        documentCommentText: document.documentCommentText,
        ...this.mapDocumentLinks(document),
      }));
      return [...existingDocuments, ...this.mapUploadedDocuments()];
    }
  },
  computed: {
    needApplyButton() {
      return this.s.tradeManagement?.actions?.includes(PROCESS_OPERATION.F_APPROVE_REQ) || this.s.tradeManagement?.actions?.includes(PROCESS_OPERATION.T_APPROVE_REQ);
    },
    applyButtonLabel() {
      if (this.s.tradeManagement?.responsibleFlg === RESPONSIBLE_FLG.TO) {
        return this.$t('Label.Apply(Awaiting Confirmation(To))');
      } else {
        return this.$t('Label.Apply(NotStarted/InputInProgress)');
      }
    },
    documentCheckbox() {
      return DOCUMENT_LINK_VARIABLES.filter(item => !/^Others\d+/.test(item.label));
    },
    documentOthersCheckbox() {
      return DOCUMENT_LINK_VARIABLES.filter(item => /^Others\d+/.test(item.label));
    }
  }
};
</script>
<style lang='scss' scoped>
.edit-attached-files-section {
  position: relative;
  font-size: 14px;
  line-height: 20px;

  .sub-heading {
    display: flex;
    justify-content: flex-end;
    margin: 16px auto;
  }

  .file {
    position: relative;
    margin-top: 12px;
    border-radius: 6px;
    padding: 12px 48px 12px 16px;
    background: $color_gray_100;

    &:first-child {
      margin-top: 12px;
    }

    &.has_error {
      background: rgba(224, 0, 1, 0.03);
    }

    &.uploaded-files {
      background: rgba($color_dark_blue, 0.1);
    }

    .user {
      max-width: 100%;
      display: flex;
      align-items: center;

      font-size: 12px;
      line-height: 20px;
      color: $color_black;

      .from_name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .close_times {
      position: absolute;
      width: 24px;
      height: 24px;
      top: 50%;
      right: 16px;
      margin-top: -12px;
      cursor: pointer;
    }
  }

  .meta {
    flex-shrink: 0;
    margin-left: 8px;
  }

  a.file_name {
    color: $color_dark_blue;
    cursor: pointer;
    text-decoration: none;
  }

  .el-form-item {
    margin: 0;
  }

  .el-textarea, .el-select.document_id {
    display: block;
    width: 100%;
    margin-top: 8px;
  }

  ::v-deep .el-input__inner {
    background: white;
    padding-right: 50px;
  }

  ::v-deep .el-textarea__inner {
    background: white;
    resize: none;
    padding-right: 65px;
  }

  ::v-deep .el-form-item__error {
    position: relative;
  }

  ::v-deep .el-textarea.is-disabled .el-textarea__inner {
    background: $color_gray_200;
    color: $color_black;
    border: 1px solid $color_gray_300;
  }

  .choose_file {
    position: relative;
    display: inline-block;

    .file_input {
      position: absolute;
      width: 1px;
      height: 1px;
      z-index: -1;
      pointer-events: none;
    }
    .el-textarea__inner{
      padding-right: 60px;
    }
  }

  .drag_and_drop_area {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 138px;
    margin-top: 24px;
    background: $color_gray_100;
    border-radius: 6px;
    text-align: center;
    font-size: 12px;
    line-height: 18px;
    color: $color_dark_blue;
    pointer-events: none;
    z-index: 2;

    img {
      display: block;
      width: 84px;
      height: auto;
      margin-bottom: 9px;
    }
  }

  &.enter > * {
    pointer-events: none;
  }

  &.enter .drag_and_drop_area {
    border: 1px dashed $color_dark_blue;
  }
}
.checkbox-group {
  .el-checkbox {
    margin-right: 11px;
  }
}
.others_checkbox {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 5px;
}
.edit-attached-files-warning {
  font-size: 14px;
  color: $color_black;
  margin-top: 16px;
  margin-bottom: 4px;
}
</style>
<style lang="scss">
.checkbox-group{
  .el-checkbox__label {
    font-size: 14px;
  }
}
.document_input {
  input[readonly] {
    cursor: not-allowed;
  }
  span{
    pointer-events: none;
  }
  .el-input__count-inner {
    background-color:white !important;
  }
} 
</style>